var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 14.333A6.667 6.667 0 107.667 1a6.667 6.667 0 000 13.333z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.601 4.768a.065.065 0 11.13 0 .065.065 0 01-.13 0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.797
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.666 11V6.833h-.833M6.508 10.855h2.319",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}

var MemoSvgInfo = /*#__PURE__*/React.memo(SvgInfo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNjY2NjcgMTQuMzMzM0MxMS4zNDg2IDE0LjMzMzMgMTQuMzMzMyAxMS4zNDg2IDE0LjMzMzMgNy42NjY2N0MxNC4zMzMzIDMuOTg0NzcgMTEuMzQ4NiAxIDcuNjY2NjcgMUMzLjk4NDc3IDEgMSAzLjk4NDc3IDEgNy42NjY2N0MxIDExLjM0ODYgMy45ODQ3NyAxNC4zMzMzIDcuNjY2NjcgMTQuMzMzM1oiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNy42MDExNiA0Ljc2ODA3QzcuNjAxMTYgNC43MzIxMSA3LjYzMDMxIDQuNzAyOTcgNy42NjYyNiA0LjcwMjk3QzcuNzAyMjEgNC43MDI5NyA3LjczMTM2IDQuNzMyMTEgNy43MzEzNiA0Ljc2ODA3QzcuNzMxMzYgNC44MDQwMiA3LjcwMjIxIDQuODMzMTcgNy42NjYyNiA0LjgzMzE3QzcuNjMwMzEgNC44MzMxNyA3LjYwMTE2IDQuODA0MDIgNy42MDExNiA0Ljc2ODA3WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjc5NjciLz4KPHBhdGggZD0iTTcuNjY2MzQgMTFWNi44MzMzN0g2LjgzMzAxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTYuNTA3ODEgMTAuODU1MUg4LjgyNjY1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPC9zdmc+Cg==";
export { MemoSvgInfo as ReactComponent };